import { useEffect } from 'react'
import {
    BorderLine,
    NavContainer,
    NavItem,
    NavLine,
    NavMain,
    NumberStyle
} from './styles'
import { NotificationReducer } from 'types/notification'
import { IAuthenticationReducer } from 'types/autentication'
import { RootReducerState } from 'types/global'
import { useSelector } from 'react-redux'

export interface NavItems {
    number: string
    name: string
    id: number
    total: string
    notRead: string
}

interface NavNotificationsProps {
    setCurrentNav: React.Dispatch<React.SetStateAction<NavItems>>
    currentNav: NavItems
    navItems: any[]
}

const NavNotifications = ({
    currentNav,
    setCurrentNav,
    navItems
}: NavNotificationsProps) => {

    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const auth: IAuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const navItemStyles = (itemId: number) => {
        if (currentNav?.id === itemId) {
            return 'font-bold text-blueTheme text-lg'
        } else return ''
    }

    const navNumberStyles = (itemId: number) => {
        if (currentNav?.id === itemId) {
            return 'text-yellow text-lg'
        } else return ''
    }

    const navBorderStyles = (itemId: number) => {
        if (currentNav?.id === itemId) {
            return 'bg-yellow'
        } else return ''
    }

    const handleChangeCurrentNav = (items: NavItems) => {
        setCurrentNav(items)
    }

    useEffect(() => {
        currentNav === undefined && setCurrentNav(navItems[0])
    }, [navItems])


    useEffect(() => {
        currentNav === undefined && setCurrentNav(navItems[0])
        const currentNavId = notificationSelector.currentNavItem
            ? notificationSelector.currentNavItem.id
            : ['location_manager'].includes(auth?.dataJwt?.profile)
                ? 2
                : 1
        let currNav = notificationSelector.notificationScreen && notificationSelector.notificationScreen?.navbar
            ? notificationSelector.notificationScreen.navbar.find((i) => currentNavId == i?.id)
            : null

        handleChangeCurrentNav(currNav)

    }, [notificationSelector.currentNavItem])

    return (
        <div className="overflow-x-auto overflow-y-hidden scrollbar-hide">
            <NavContainer>
                {navItems.map((item, index) => (
                    <NavMain
                        onClick={() => handleChangeCurrentNav(item)}
                        key={index}
                    >
                        <NavItem
                            data-testid="test-notification-tabs-headers"
                            className={navItemStyles(item?.id)}>
                            {item?.name}
                        </NavItem>

                        {item?.number && (
                            <NumberStyle
                                className={navNumberStyles(item?.id)}
                            >
                                {item?.number}
                            </NumberStyle>
                        )}

                        <NavLine className={navBorderStyles(item?.id)} />
                    </NavMain>
                ))}
            </NavContainer>

            <BorderLine />
        </div>
    )
}

export default NavNotifications
